module.exports = __webpack_public_path__ + "static/accessible_wifi-19e440bfb5b2a96fdc5e90b34b0315fa.svg";